var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHamburgerMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 30,
    viewBox: "0 0 90 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2155 0.536621H28.0098L41.2192 28.3988L45.1391 19.7276L36.2155 0.536621Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9328 29.4642L61.6489 0.536621H53.598L41.05 28.0319L41.7256 29.4642H47.9328Z",
    fill: "url(#paint0_linear_1_2947)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7739 22.8739H74.3446C70.0588 22.8104 66.6033 19.3109 66.6033 15C66.6033 10.6467 70.1221 7.11897 74.4643 7.11897V0C66.2022 0 59.5024 6.71681 59.5024 15C59.5024 23.2267 66.1178 29.9012 74.3024 29.993L74.7176 30L74.7739 22.8739Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4266 15C89.4266 6.71681 82.7268 0 74.4644 0V7.11897C78.8066 7.11897 82.3254 10.6467 82.3254 15C82.3254 19.3532 78.8066 22.881 74.4644 22.881V29.993C74.5488 29.993 74.6333 30 74.7177 30C82.8675 29.8659 89.4266 23.1985 89.4266 15Z",
    fill: "url(#paint1_linear_1_2947)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78996 20.0374L23.1325 14.8022C23.1114 12.9325 22.4428 11.218 21.345 9.87744L7.00244 15.1056C7.02355 16.9753 7.69211 18.6968 8.78996 20.0374Z",
    fill: "url(#paint2_linear_1_2947)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9619 30.0001C20.3386 30.0001 25.0538 27.1568 27.6858 22.8882L21.528 19.3252C20.1205 21.463 17.7066 22.8812 14.9549 22.8812C12.5059 22.8812 10.3172 21.7594 8.87448 19.9955L1.99878 22.5002C2.04804 22.5778 2.09026 22.6624 2.13249 22.7401C4.76453 27.0933 9.5219 30.0001 14.9619 30.0001Z",
    fill: "url(#paint3_linear_1_2947)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9618 0C6.69976 0 0 6.71681 0 15C0 17.5753 0.633383 19.9671 1.77347 22.0837L2.18868 22.8175L9.09252 20.2493L8.66325 19.6989C7.68502 18.3866 7.10793 16.7638 7.10793 15C7.10793 10.6467 10.6267 7.11897 14.9689 7.11897C19.2829 7.11897 22.7806 10.5974 22.8299 14.9154L29.7125 12.4177C28.481 5.36219 22.3442 0 14.9618 0Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2947",
    x1: 59.3026,
    y1: -3.11828,
    x2: 45.6075,
    y2: 26.5778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7458,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2947",
    x1: 86.0247,
    y1: 3.25139,
    x2: 74.6016,
    y2: 21.1739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_2947",
    x1: 5.089,
    y1: 18.9957,
    x2: 18.3829,
    y2: 13.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_2947",
    x1: 20.4969,
    y1: 16.837,
    x2: 13.3714,
    y2: 24.4565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHamburgerMenu);
export default __webpack_public_path__ + "static/media/icon-hamburger-menu.57665daf80c4e025eed9a047fd8876df.svg";
export { ForwardRef as ReactComponent };